import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Payment } from 'src/app/assabil-sales/models/entities/payment';
import { PaymentService } from 'src/app/assabil-sales/services/payment-service';
import { PaymentWidgetModal } from '../payment-widget/payment-widget.component';
import { MatDialog } from '@angular/material/dialog';
import { Field } from 'src/app/tools/models/dtos/field';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { RoleLovComponent } from 'src/app/assabil-admin/components/master-data/role/role-lov/role-lov.component';
import { PersonLovComponent } from 'src/app/assabil-admin/components/master-data/person/person-lov/person-lov.component';
import { PaymentTermLovComponent } from 'src/app/assabil-admin/components/control-tables/payment-term-lov/payment-term-lov.component';
import { BankLovComponent } from 'src/app/assabil-admin/components/control-tables/bank-lov/bank-lov.component';
import { UserService } from 'src/app/assabil-kernel/services/user-service';
import { PaymentTerm } from 'src/app/assabil-kernel/models/entities/control-tables/payment-term';


@Component({
    selector: 'payment-list',
    templateUrl: './payment-list.component.html',
    styleUrls: ['./payment-list.component.scss']
})


export class PaymentListComponent extends BasePage2<Payment> {

    payments        : Payment[] = [];

    serviceCode     : string;
    roleCode        : string;
    personCode      : string;
    partnerCode     : string;
    startDate       : Date;
    endDate         : Date;



    constructor(
        protected toastr            : ToastrService,
        protected paymentService    : PaymentService,
        protected router            : Router,
        protected baseService       : BaseService,
        protected leanUtilsService  : LeanUtilsService, 
        protected userService       : UserService,
        protected dialog            : MatDialog,
        protected location          : Location) {
         super(toastr, router, baseService, leanUtilsService, location);

         this.entityName = 'payment';
    }

    //---------------------------------------------------------------------------------------------------------
    getRows(): Payment[] {
        return this.payments;
    }
    //---------------------------------------------------------------------------------------------------------
  

    //---------------------------------------------------------------------------------------------------------
    loadData() {
        this. paymentService.paymentsGet(this.serviceCode, this.roleCode, this.personCode, this.partnerCode, this.startDate, this.endDate).then(result => {
            this.payments = result;
        });
    }
    //---------------------------------------------------------------------------------------------------------
  
    //---------------------------------------------------------------------------------------------------------
    selectRow(payment : Payment){
        let dialogRef = this.dialog.open(PaymentWidgetModal, {autoFocus : false, hasBackdrop : false,  data : {payment : payment, columns : this.formFields}});
        dialogRef.afterClosed().subscribe(result => {
        if(result){
            this.loadData();
        }
        });
    }
    //---------------------------------------------------------------------------------------------------------
    
    //---------------------------------------------------------------------------------------------------------
    new() {
        let payment          = new Payment();
        payment.person       = this.userService.userInfo.person
        payment.role         = this.userService.userInfo.person.role;
        payment.paymentTerm  = new PaymentTerm();
        payment.theDate      = new Date();
        payment.edit         = true; 
        payment.inserted     = true;  
        this.selectRow(payment);
    }
    //---------------------------------------------------------------------------------------------------------
    
    //--------------------------------------------------------------------------------------------------------
    enrichField(field : Field){
        if (field.prop == 'partner')    { field.modal = PartnerLovComponent;    field.subProp = 'name';}
        if (field.prop == 'role')       { field.modal = RoleLovComponent;       field.subProp = 'name';}
        if (field.prop == 'person')     { field.modal = PersonLovComponent;     field.subProp = 'name';}
        if (field.prop == 'paymentTerm'){ field.modal = PaymentTermLovComponent;field.subProp = 'name';}
        if (field.prop == 'bank')       { field.modal = BankLovComponent;       field.subProp = 'name';}
    }
     //---------------------------------------------------------------------------------------------------------
  
}
